import React from 'react';
import './TypingIndicator.css';

const TypingIndicator = () => {
  return (
    <div className="message message-assistant typing">
      <div className="message-avatar">🤖</div>
      <div className="message-content-wrapper">
        <div className="message-header">
          <span className="message-sender">Legal Assistant</span>
        </div>
        <div className="typing-indicator">
          <div className="typing-dots">
            <span className="dot"></span>
            <span className="dot"></span>
            <span className="dot"></span>
          </div>
          <span className="typing-text">Analyzing documents...</span>
        </div>
      </div>
    </div>
  );
};

export default TypingIndicator;
